<h1 class="heading">
  {{heading}}
</h1>

@if (subheading) {
  <h4
    class="subheading">
    {{subheading}}
  </h4>
}

<div class="icon-container">
  <mat-icon class="icon">
    {{icon}}
  </mat-icon>
</div>
